import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateOrderOfSubCategories = async (placeId, nested, positions) => {
  if (!placeId || !nested || !positions) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/nested/${nested}/order`,
    data: { positions },
  });
};